import { toast } from "react-toastify";
import {
  fetchStockinRequestPOStart,
  fetchStockinRequestPOSuccess,
  fetchStockinRequestPOFailure,
} from "./reducer";

import { STOCK_IN_REQUEST_PO } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const stockinRequestPO =
  (id, jsonObj, setLoading, onSuccess) => async (dispatch) => {
    dispatch(fetchStockinRequestPOStart());
    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        STOCK_IN_REQUEST_PO(id),
        "POST",
        jsonObj
      );

      if (response?.error) {
        dispatch(fetchStockinRequestPOFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchStockinRequestPOSuccess(response));
        dispatch(setSuccessMessage(true));
        toast.success(response.Message);
        onSuccess && onSuccess(response);
      }
    } catch (error) {
      dispatch(fetchStockinRequestPOFailure("Something went wrong"));
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };